/**
 * Sage Intacct Web Services (XML): getAPISession using sender + entity user credentials from connector parameters.
 * Required: senderid, senderpassword, userid, companyid, userpassword. Optional: locationid.
 * XML gateway URL comes from the master connector mc_base_url (seeded in global schema).
 */

import { toast } from 'react-toastify';
import { buildConnectorParametersDecryptUrl } from '../../utils/connectorParametersApi';

const token = localStorage.getItem('token');

export const getSageIntacctXmlCredentialsAndCreateToken = async (connectorId, mcId, masterConnectors) => {
  const xmlMaster = masterConnectors.find(
    (mc) =>
      (mc.mcRecId?.toString() === mcId?.toString() || mc.mcId?.toString() === mcId?.toString()) &&
      (mc.mcConnectorType === 'SAGE_INTACCT_XML' ||
        (mc.mcName && mc.mcName.toLowerCase().includes('sage intacct') && mc.mcName.toLowerCase().includes('xml')))
  );

  if (!xmlMaster) {
    throw new Error('Sage Intacct XML master connector not found');
  }

  const paramResponse = await fetch(buildConnectorParametersDecryptUrl(connectorId), {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!paramResponse.ok) {
    throw new Error(`Failed to fetch connector parameters: ${paramResponse.status}`);
  }

  const connectorParams = await paramResponse.json();
  const names = (n) => connectorParams.find((p) => p.scpName === n)?.scpValue;
  const required = ['senderid', 'senderpassword', 'userid', 'companyid', 'userpassword'];
  const missing = required.filter((k) => !names(k) || String(names(k)).trim() === '');
  if (missing.length) {
    throw new Error(
      `Missing required parameters: ${missing.join(', ')}. Configure them in Parameters before connecting.`
    );
  }

  const sessionUrl = `${process.env.REACT_APP_BACKEND_URL}synctrack/sage/intacct-xml/session?ctdId=${encodeURIComponent(connectorId)}`;
  const sessionRes = await fetch(sessionUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  const sessionJson = await sessionRes.json().catch(() => ({}));
  if (!sessionRes.ok) {
    throw new Error(sessionJson.error || sessionJson.message || `Session request failed (${sessionRes.status})`);
  }

  toast.success('Sage Intacct XML session established');
  return {
    status: 'success',
    sessionId: sessionJson.sessionId,
    endpoint: sessionJson.endpoint,
    sessionTimeout: sessionJson.sessionTimeout,
  };
};
